// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationHeader_wrapper__o9YMS","link":"NavigationHeader_link__DDTRx"};